function inLoopNonParallelFactory($q, createPromiseFunction) {

	var responses = [];
	var defer = null;

	function inLoopNonParallel(endPoint, params, createPromise) {
		var item = params.shift();

		if (!item) {
			defer.resolve(responses);
			return;
		}

		createPromiseFunction(endPoint, item)
			.then(function (response) {
				responses.push(response);
				inLoopNonParallel(endPoint, params, true);
			})
			.catch(function (error) {
				responses.push(error);
				inLoopNonParallel(endPoint, params, true);
			});

		if (!createPromise) {
			defer = $q.defer();
			return defer.promise;
		}

	}

	return inLoopNonParallel;
}

export default inLoopNonParallelFactory;
